import { makeStyles } from '@material-ui/core';

export default makeStyles(
  theme => ({
    tableBottomRow: {
      background: theme.palette.background.default,
    },
    tableBottomCell: {
      height: 48,
      padding: [16, 12],
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 600,
    },
    sideLetterPendingContainer: {
      marginLeft: 0,
    },
    sideLetterPendingList: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
    },
    sideLetterPendingItem: {
      margin: 0,
      padding: 0,
      display: 'flex',
      alignItems: 'center',
    },
    iconWrapper: {
      padding: [0, 8],
      display: 'flex',
    },
    sideLetterPendingButton: {
      justifyContent: 'flex-start',
    },
  }),
  { name: 'SideLetterPending' },
);
